import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";
import { paymentList } from "constants/payment";


export const getPaymentList = async (dispatch, pageNum, filters,sortOptionJSON) => {
  try {
    const res = await api.payment_list(pageNum, filters,sortOptionJSON);
    dispatch({ type: paymentList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: paymentList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};


export const getPaymentDetailsById = async (id) => {
  try {
    const res = await api.payment_Details(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};


export const approveRejectPayment = async (id, bodyData) => {
  try {
    const res = await api.approve_reject_payment(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};